
export const Mirror360Theme = {
      
  primary: '#388087',
  primaryLight: '#95a7a9',
  secondary: '#6fb3b8',
  third: '#badfe7',
  forth: '#c2edce',
  white: '#fefefe',
  black: '#444444',
  background: '#f6f6f2',
  
};

// primary: '#02a95c',
// secondary: '#608a89',
// background: '#e8f2f4',
// white: '#fefefe',
// black: '#444444',

// primary: '#6daffe',
// secondary: '#4374c7',
// background: '#ffffff',
// color1: '#b9732f',
// color2: '#edf6ff'



// primary: '#363538',
// secondary: '#8d8c8a',
// background: '#f6f6f6',
// color1: '#408697',
// color2: '#52d6f4'

